// mutations 命命规则  全大写  下划线隔开

const mutations = {
  user (state, user) {
    state.user = user
  },
  menuTree (state, menuTree) {
    state.menuTree = menuTree
  },
  menuClickInOtherPage (state, menuClickInOtherPage) {
    state.menuClickInOtherPage = menuClickInOtherPage
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js